import { Server } from '#enums';
import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-status-badge',
  imports: [NgClass, TranslatePipe],
  templateUrl: './project-status-badge.html',
  styleUrl: './project-status-badge.scss',
})
export class ProjectStatusBadgeComponent {
  status = input.required<Server.ProjectStatus>();
  isDeleted = input<boolean>(false);
  useIcon = input<boolean>(false);

  ProjectStatus = Server.ProjectStatus;

  cssClass = computed(() => {
    // Deleted projects always show as deleted (red)
    if (this.isDeleted()) {
      return 'project-status--deleted';
    }

    const status = this.status();

    if (status === Server.ProjectStatus.Active) {
      return 'project-status--active';
    }
    return 'project-status--closed';
  });

  iconClass = computed(() => {
    // Deleted projects show trash icon
    if (this.isDeleted()) {
      return 'pi-trash';
    }

    const status = this.status();

    if (status === Server.ProjectStatus.Active) {
      return 'pi-check-circle';
    }

    return 'pi-ban';
  });

  translationKey = computed(() => {
    // Deleted projects always show as "Deleted"
    if (this.isDeleted()) {
      return 'projectEdit.statusDeleted';
    }

    const status = this.status();
    if (status === Server.ProjectStatus.Closed) {
      return 'projectEdit.statusClosed';
    }
    return 'projectEdit.statusActive';
  });
}
